
const PasswordConfirm = ({ fields, member, hasEmail }) => {

  return (
    <>
                <h3>ログイン情報</h3>
<p>「送信」ボタンをクリックしてください。</p>
              <dl>
                <dt>ログインID（会員番号）<span class="red">*</span></dt>
                <dd>{ fields.loginId }</dd>
                <dt>パスワード<span class="red">*</span></dt>
                <dd>*********</dd>
                <dt className={ hasEmail ? "hideInputRow" : "" }>Email<span class="red">*</span></dt>
                <dd className={ hasEmail ? "hideInputRow" : "" }>{fields.affiliationEmail}</dd>
                </dl>
    </>
  );
}

export default PasswordConfirm;
